import { CardActions, CardContent, TextField, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyResetToken } from "../api/auth";
import { passwordReset } from "../api/auth";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  height: "56px",
}));

export default function PasswordReset(props) {
  const isFirstRender = useRef(true); // 初回レンダリングを追跡するref
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (isFirstRender.current) {
      verifyResetToken(token)
        .then((response) => {})
        .catch((error) => {
          const errorMessage = error.response.data.message;
          navigate(
            `/verify_token_faile?message=${encodeURIComponent(errorMessage)}`,
          );
        })
        .finally(() => {
          isFirstRender.current = false;
        });
    }
  }, [token, navigate]);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    getValues,
  } = useForm();

  // パスワードのバリデーションルール
  const passwordRules = {
    required: "パスワードは必須です",

    pattern: {
      value:
        /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z\d!@#$%^&*()\-_+=\[\]{}|\\:;"'<>,.?/~`]{8,}$/,
      message: "パスワードは英数字を含む8文字以上で入力してください",
    },
    validate: {
      notConatinPassword: (value) => {
        return (
          !/password/i.test(value) ||
          "「password」という文字列を含む事はできません"
        );
      },
    },
  };

  // 確認用パスワードのバリデーションルール
  const confirmPasswordRules = {
    required: "パスワード(確認)は必須です",
    validate: {
      matchesPreviousPassword: (value) => {
        const password = getValues("password");
        return password === value || "パスワードが一致しません";
      },
    },
  };

  const onsubmit = (data) => {
    if (data.password === data.confirmPassword) {
      passwordReset(data.password, token).then(
        (success) => {
          navigate("/password_reset_complete");
        },
        (error) => {
          setError("root.serverError", {
            type: "server",
            message: error.response.data.message,
          });
        },
      );
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onsubmit, onerror)}
      noValidate
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px",
          width: "552px",
          maxWidth: "90vw",
          height: "400px",
          backgroundColor: "common.white.main",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "16px",
            gap: "16px",
            width: "100%",
            height: "500px",
          }}
        >
          <Typography variant="h5" component="h1" sx={{ mb: 3 }}>
            パスワードリセット
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: "50px",
              gap: "24px",
              width: "100%",
              height: "128px",
            }}
          >
            <CustomTextField
              id="password"
              label="パスワード"
              variant="outlined"
              size="medium"
              type="password"
              sx={{
                marginBottom: "25px",
              }}
              {...register("password", passwordRules)}
              error={"password" in errors}
              helperText={errors.password?.message}
            />
            <CustomTextField
              id="confirmPassword"
              label="パスワード(確認)"
              variant="outlined"
              size="medium"
              type="password"
              {...register("confirmPassword", confirmPasswordRules)}
              error={"confirmPassword" in errors}
              helperText={errors.confirmPassword?.message}
            />
          </Box>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            size="large"
            sx={{
              alignItems: "center",
              padding: "8px 22px",
              width: "100%",
              height: "42px",
              marginTop: "10px",
            }}
          >
            パスワードを更新
          </Button>
        </CardContent>
        {errors.root?.serverError && (
          <Typography
            variant="body2"
            sx={{
              color: "error.main",
              marginBottom: "15px",
            }}
          >
            {errors.root.serverError?.message}
          </Typography>
        )}
      </Container>
      <CardActions
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          padding: "0px",
          gap: "8px",
          width: "552px",
          maxWidth: "90vw",
          height: "20px",
        }}
      >
        <Link
          href="/login"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0px",
            width: "184px",
            height: "20px",
            marginTop: "10px",
          }}
        >
          <Typography variant="body2">ログイン画面に戻る</Typography>
        </Link>
      </CardActions>
    </Box>
  );
}
